import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useMemo } from 'react';
import { TRU_NARRATIVE_VERIFIED_STATUS } from '../constants';

export const usePossibleVerificationStatuses = () => {
    const { statuses = [] } = useComponentConfig();

    return useMemo(() => {
        // verified status is hardcoded
        // so we add it manually
        return statuses
            .concat([
                TRU_NARRATIVE_VERIFIED_STATUS
            ]);
    }, [
        statuses
    ]);
};
